export default __webpack_public_path__ + "static/supportSystemListingImage2-1c2f44304fa9f4d87977db90a24e44df.webp";